import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import {
  HeaderContainer,
  HeaderContent,
  Logo,
  Nav,
  NavItem,
  MobileMenuButton,
  LanguageSelector,
  LanguageOption
} from './styles';
import { useLanguage } from '../../contexts/LanguageContext';

interface HeaderProps {
  toggleMobileMenu: () => void;
}

const Header: React.FC<HeaderProps> = ({ toggleMobileMenu }) => {
  const { language, setLanguage } = useLanguage();
  const [isScrolled, setIsScrolled] = useState(false);
  return (
    <HeaderContainer>
      <HeaderContent>
        <Logo>
          <Link to="/">
            <img src="/back_imgs/Logo_Tech.jpeg" alt="Tech By Tech Logo" />
            <div>
              <h1>Tech By Tech</h1>
              <p>{language === 'pt' ? 'DANDO VIDA À IMAGINAÇÃO' : 'BRINGING IMAGINATION TO LIFE'}</p>
            </div>
          </Link>
        </Logo>
        <Nav>
          <NavItem>
            <Link to="/">{language === 'pt' ? 'Início' : 'Home'}</Link>
          </NavItem>
          <NavItem>
            <Link to="/servicos">{language === 'pt' ? 'Serviços' : 'Services'}</Link>
          </NavItem>
          <NavItem>
            <Link to="/produtos">{language === 'pt' ? 'Produtos' : 'Products'}</Link>
          </NavItem>
          <NavItem>
            <Link to="/sobre">{language === 'pt' ? 'Sobre' : 'About'}</Link>
          </NavItem>
          <NavItem>
            <Link to="/contacto">{language === 'pt' ? 'Contacto' : 'Contact'}</Link>
          </NavItem>
        </Nav>
        <LanguageSelector>
          <LanguageOption 
            active={language === 'pt'} 
            onClick={() => setLanguage('pt')}
          >
            PT
          </LanguageOption>
          <LanguageOption 
            active={language === 'en'} 
            onClick={() => setLanguage('en')}
          >
            EN
          </LanguageOption>
        </LanguageSelector>
        <MobileMenuButton onClick={toggleMobileMenu}>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3,6H21V8H3V6M3,11H21V13H3V11M3,16H21V18H3V16Z" />
          </svg>
        </MobileMenuButton>
      </HeaderContent>
    </HeaderContainer>
  );
};

export default Header;